// Pagamentos já baixados na ficha (parcelas e débitos avulsos), o mais recente primeiro; estorno só com a permissão c086
import React from "react";
import { Icon, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { toCurrency } from "utils/NumberUtils";
import { useMaterialUIController } from "context";
import { coresDoTema, FONTE } from "assets/coresTema";
import { dataBR } from "./baixaUtils";

const COLUNAS = ["Pago em", "Baixado em", "Item", "Valor pago", "Desconto", "Acréscimo", "Forma", "Por", ""];

export default function HistoricoPagamentos({ pagamentos, podeEstornar, onEstornar }) {
    const [controller] = useMaterialUIController();
    const cores = coresDoTema(controller.darkMode);

    if (!pagamentos || pagamentos.length === 0) {
        return (
            <MDBox py={4} textAlign="center">
                <MDTypography variant="button" color="text">Nenhum pagamento baixado nesta ficha.</MDTypography>
            </MDBox>
        );
    }

    return (
        <>
            {!podeEstornar && (
                <MDTypography variant="caption" color="text" display="block" mb={1}>
                    Estornar uma baixa exige a permissão &quot;Estornar Baixa de Pagamento&quot; no perfil.
                </MDTypography>
            )}
            <TableContainer sx={{ border: `1px solid ${cores.borda}`, borderRadius: 2 }}>
                <Table size="small" sx={{ minWidth: 760 }}>
                    <TableHead sx={{ display: "table-header-group" }}>
                        <TableRow>
                            {COLUNAS.filter((c, i) => podeEstornar || i < COLUNAS.length - 1).map((c, i) => (
                                <TableCell key={i} align={i >= 3 && i <= 5 ? "right" : "left"} sx={{ py: 0.75, px: 1, backgroundColor: cores.painelEscuro }}>
                                    <MDTypography variant="caption" fontWeight="bold" color="text" sx={{ fontSize: FONTE.cabecalho }}>{c}</MDTypography>
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {pagamentos.map((p, i) => (
                            <TableRow key={`${p.idItem}-${i}`}>
                                <TableCell sx={{ py: 0.75, px: 1 }}><MDTypography variant="button">{dataBR(p.dataPagamento)}</MDTypography></TableCell>
                                <TableCell sx={{ py: 0.75, px: 1 }}><MDTypography variant="caption" color="text">{dataBR(p.dataBaixa)}</MDTypography></TableCell>
                                <TableCell sx={{ py: 0.75, px: 1 }}><MDTypography variant="button">{p.item}</MDTypography></TableCell>
                                <TableCell align="right" sx={{ py: 0.75, px: 1 }}><MDTypography variant="button" fontWeight="bold">{toCurrency(p.valorPago)}</MDTypography></TableCell>
                                <TableCell align="right" sx={{ py: 0.75, px: 1 }}><MDTypography variant="caption">{p.desconto > 0 ? toCurrency(p.desconto) : "-"}</MDTypography></TableCell>
                                <TableCell align="right" sx={{ py: 0.75, px: 1 }}><MDTypography variant="caption">{p.acrescimo > 0 ? toCurrency(p.acrescimo) : "-"}</MDTypography></TableCell>
                                <TableCell sx={{ py: 0.75, px: 1 }}><MDTypography variant="caption">{p.forma || "-"}</MDTypography></TableCell>
                                <TableCell sx={{ py: 0.75, px: 1 }}><MDTypography variant="caption">{p.usuario || "-"}</MDTypography></TableCell>
                                {podeEstornar && (
                                    <TableCell sx={{ py: 0.25, px: 1 }} align="center">
                                        <Tooltip title={p.estornavel ? "Estornar esta baixa" : (p.motivo || "")}>
                                            <span>
                                                <IconButton size="small" color="error" disabled={!p.estornavel} onClick={() => onEstornar(p)}
                                                    aria-label="Estornar esta baixa">
                                                    <Icon fontSize="small">undo</Icon>
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}
